const EyeVisible = ({ ...props }) => {
    const {handleClick} = props
    return (
        <svg
            width="20px"
            height="16px"
            viewBox="0 0 18 12"
            version="1.1"
            onClick={(e) => {
                e.stopPropagation();
                handleClick && handleClick();
            }}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            >
            <title>show-password</title>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    transform="translate(-1234.000000, -517.000000)"
                    fill="#505050"
                    fillRule="nonzero">
                    <g transform="translate(859.000000, 218.000000)">
                        <g transform="translate(24.000000, 84.000000)">
                            <g transform="translate(0.000000, 198.000000)">
                                <path d="M359.81248,20.0937426 C359.554044,20.0978053 359.144032,20.163437 358.897241,20.2402553 C359.012711,20.4433016 359.107726,20.7976956 359.109357,21.031269 C359.109357,21.936895 358.374362,22.6718901 357.468735,22.6718901 C357.235162,22.6702593 356.880768,22.575245 356.677722,22.4597744 C356.606997,22.7050493 356.549605,23.1112563 356.549605,23.3665162 C356.549605,25.1730476 358.01579,26.6392612 359.82235,26.6392612 C361.62891,26.6392612 363.095095,25.1730476 363.095095,23.3665162 C363.095095,21.5599562 361.62891,20.0937426 359.82235,20.0937426 C359.819632,20.0937426 359.815198,20.0937426 359.81248,20.0937426 Z M368.147993,22.9472915 C366.559242,19.8473805 363.413927,17.7500268 359.81248,17.7500268 C356.211033,17.7500268 353.064831,19.8488396 351.476967,22.9475776 C351.42069,23.0588711 351.375029,23.2504448 351.375029,23.3751565 C351.375029,23.4998682 351.42069,23.6914418 351.476967,23.8027353 C353.065717,26.9026463 356.211033,29 359.81248,29 C363.413927,29 366.560129,26.9011872 368.147993,23.8024492 C368.204269,23.6911557 368.249931,23.4995821 368.249931,23.3748704 C368.249931,23.2501587 368.204269,23.058585 368.147993,22.9472915 Z M359.81248,27.5937534 C356.922339,27.5937534 354.272752,25.9824291 352.8419,23.3750134 C354.272752,20.7675978 356.922053,19.1562735 359.81248,19.1562735 C362.702907,19.1562735 365.352208,20.7675978 366.78306,23.3750134 C365.352494,25.9824291 362.702907,27.5937534 359.81248,27.5937534 Z"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default EyeVisible;
